import { render, staticRenderFns } from "./TestVideoResultsList.vue?vue&type=template&id=b008d1aa&scoped=true&"
import script from "./TestVideoResultsList.vue?vue&type=script&lang=js&"
export * from "./TestVideoResultsList.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoResultsList.vue?vue&type=style&index=0&id=b008d1aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b008d1aa",
  null
  
)

export default component.exports